import React, { ComponentProps } from 'react';
import { Backdrop } from '@components/Backdrop/Backdrop.component';
import styles from './Overlay.module.scss';

function Overlay({ visible, ...rest }: Omit<ComponentProps<typeof Backdrop>, 'open'> & { visible: boolean }) {
  return <Backdrop className={styles.overlay} open={visible} {...rest} />;
}

export { Overlay };
